
import { defineComponent, reactive, toRefs, PropType, ref, computed } from 'vue'
import InputHeader from '@/components/InputHeader.vue'

export default defineComponent({
  name: 'QuantityContainer',
  components: { InputHeader },
  props: {
    quantity: {
      type: [Number, String]
    },
    partial: {
      type: Number
    },
    selected: {
      type: [Boolean, Number],
      default: false
    },
    editable: {
      type: Boolean,
      default: false
    },
    displayDisabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: [String, Number]
    }
  },
  emits: ['update'],
  setup (props, { emit }) {

    const state = reactive({
      editing: ref(false)
    })

    function update (value) {
      emit('update', value)
    }

    return {
      ...toRefs(state),
      update,
    }
  }
})
